import { i18nKeys } from 'translationTypes'
import i18n from '../../../i18n'

export default {
  h1: () => i18n.t(i18nKeys.orientationTypeSelector__h1),
  mailItButton: () => i18n.t(i18nKeys.orientationTypeSelector__mailItButton),
  mailItTitle: () => i18n.t(i18nKeys.orientationTypeSelector__mailItTitle),
  pickUpButton: () => i18n.t(i18nKeys.orientationTypeSelector__pickUpButton),
  pickUpTitle: () => i18n.t(i18nKeys.orientationTypeSelector__pickUpTitle),
  kitModalButton: () =>
    i18n.t(i18nKeys.orientationTypeSelector__kitModalButton),
}
